/* The Atelier: header behaviour (loaded defer from sections/at-header.liquid). Every listener is delegated from the
   document, so a theme-editor re-render of the header needs no re-binding; the guard stops a second copy binding twice.
   - Desktop menu. Hover opening and closing are CSS (atelier.css, no timers). This keeps one panel open, closes on
     Escape (focus returns to the item), on focus leaving the item and on a click outside, and loads a panel's photo
     on the first mouse enter or focus of its item.
   - Phone menu accordions: Dawn's MenuDrawer (global.js) binds every <summary> inside header-drawer as a sub-menu and
     traps focus inside it. These are plain disclosures, so the click is stopped before it reaches that listener; the
     native toggle still happens.
   - Currency: the drawer and footer carry .at-currency-trigger buttons that open the one selector in .at-tools (only
     rendered when the header's show_currency setting is on; otherwise the triggers are display:none).
   - Header search bar: the search icon grows into a field across the header (openSearch / closeSearch below).
   - Instant search: loads at-search.js/css and the index when a search UI first opens, or on a submitted /search page
     for its help rows and partial-match heading (see bootSearch below). */
(function () {
  if (window.atHeaderBound) return;
  window.atHeaderBound = true;

  function panelOf(li) {
    return li && li.querySelector(':scope > details');
  }
  function closeOthers(keep) {
    document.querySelectorAll('.at-navitem > details[open]').forEach(function (d) {
      if (d !== keep) d.open = false;
    });
  }
  function loadPhoto(li) {
    var img = li.querySelector('.at-panel-image img[data-src]');
    if (!img) return;
    img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  // pointerover with a relatedTarget outside the item is pointerenter on the item.
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var li = e.target.closest && e.target.closest('.at-navitem');
    var d = panelOf(li);
    if (!d || (e.relatedTarget && li.contains(e.relatedTarget))) return;
    var panel = li.querySelector('.at-panel');
    if (panel) panel.hidden = false;
    loadPhoto(li);
    if (!d.open) closeOthers(null);
  });
  // Once a panel has begun to show under the mouse, moving to another item swaps the panels at once
  // (.at-navlist.is-swap, atelier.css): fading one in over the other showed both panels' links through each other for
  // about 200ms. The first panel still fades in, and the last one out once the mouse leaves the menu. The class is set
  // ahead of the move (here, as the first panel starts to show), not as the mouse reaches the next item: by then the
  // browser has often already started that panel's fade.
  document.addEventListener('transitionstart', function (e) {
    var li = e.propertyName === 'opacity' && e.target.matches && e.target.matches('.at-navlist > .at-navitem > .at-panel') && e.target.parentElement;
    if (li && li.matches(':hover')) li.parentElement.classList.add('is-swap');
  });
  document.addEventListener('pointerout', function (e) {
    var li = e.target.closest && e.target.closest('.at-navitem');
    if (li && !(e.relatedTarget && li.contains(e.relatedTarget))) {
      var panel = li.querySelector('.at-panel');
      if (panel) panel.hidden = false;
    }
    var list = e.target.closest && e.target.closest('.at-navlist.is-swap');
    if (list && !(e.relatedTarget && list.contains(e.relatedTarget))) list.classList.remove('is-swap');
  });
  document.addEventListener('focusin', function (e) {
    var li = e.target.closest && e.target.closest('.at-navitem');
    if (panelOf(li)) loadPhoto(li);
  });
  // toggle does not bubble; the capture phase still reaches the document.
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (!d.open || !d.matches || !d.matches('.at-navitem > details')) return;
      loadPhoto(d.parentElement);
      closeOthers(d);
    },
    true
  );
  // Tabbing past the panel's last link (or back before the item) closes it. A click on the panel's own whitespace has
  // no relatedTarget and is left to the click handler below.
  document.addEventListener('focusout', function (e) {
    var li = e.target.closest && e.target.closest('.at-navitem');
    var d = panelOf(li);
    if (d && d.open && e.relatedTarget && !li.contains(e.relatedTarget)) d.open = false;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.at-navitem > details').forEach(function (d) {
      if (!d.open && !d.parentElement.matches(':hover')) return;
      if (d.parentElement.contains(document.activeElement)) d.querySelector('summary').focus();
      d.open = false;
      // CSS hover outlives Escape while the pointer stays here. Release it on leaving or an explicit reopen.
      var panel = d.parentElement.querySelector('.at-panel');
      if (panel) panel.hidden = true;
    });
  });
  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('.at-navitem > details > summary');
    var panel = summary && summary.closest('.at-navitem').querySelector('.at-panel');
    if (panel) panel.hidden = false;
  });

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest && e.target.closest('.at-drawer-body .at-drawer-acc > summary')) e.stopPropagation();
    },
    true
  );
  // global.js gives these summaries role=button and aria-expanded, and keeps it in step from a click listener that the
  // stopped click above never reaches, so each group was announced as collapsed while open. It follows the toggle.
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('.at-drawer-body .at-drawer-acc')) return;
      var summary = d.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', d.open);
    },
    true
  );

  // A search field that sits mid-page (the 404's, form[data-at-lift]) moves up to just under the sticky header when
  // focused on a phone, so the instant results have the screen above the keyboard (at 390x844 the keyboard left no
  // result row visible). Here rather than in at-search.js, which only loads on this first focus.
  document.addEventListener('focusin', function (e) {
    var f = e.target.form;
    if (f && f.hasAttribute('data-at-lift') && e.target.type === 'search' && window.matchMedia('(max-width:800px)').matches)
      f.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });

  // Shopify's cookie banner sits fixed over the bottom of the screen until she answers it. Keyboard focus that the
  // browser scrolls into view could land behind it, even at the very end of the footer. Reserve its full height in
  // the page as well as scroll padding, so those last controls have room to move above it.
  (function () {
    var root = document.documentElement;
    var watched = null;
    var sizer = window.ResizeObserver && new ResizeObserver(size);
    function size() {
      var height = watched ? Math.ceil(watched.getBoundingClientRect().height) : 0;
      root.style.setProperty('--at-cookie-height', height ? height + 12 + 'px' : '0px');
      root.style.scrollPaddingBottom = height ? height + 12 + 'px' : '';
      revealFocus();
    }
    function revealFocus() {
      var focused = document.activeElement;
      if (!watched || !focused || focused === document.body || focused === root || watched.contains(focused)) return;
      var banner = watched.getBoundingClientRect();
      var box = focused.getBoundingClientRect();
      if (box.width && box.height && box.bottom > banner.top && box.top < banner.bottom && box.right > banner.left && box.left < banner.right) {
        // A fixed Klaviyo dialog paints above the banner. Scrolling the page cannot move its fields, and need not.
        var hit = document.elementFromPoint(
          (Math.max(box.left, banner.left) + Math.min(box.right, banner.right)) / 2,
          (Math.max(box.top, banner.top) + Math.min(box.bottom, banner.bottom)) / 2
        );
        if (hit && watched.contains(hit)) window.scrollBy({ top: box.bottom - banner.top + 12, behavior: 'instant' });
      }
    }
    function sync() {
      var banner = document.getElementById('shopify-pc__banner');
      var shown = banner && banner.getClientRects().length ? banner : null; // fixed: offsetParent is always null
      if (shown === watched) return;
      if (watched && sizer) sizer.unobserve(watched);
      watched = shown;
      if (shown && sizer) sizer.observe(shown);
      size();
    }
    new MutationObserver(sync).observe(document.body, { childList: true, attributes: true, subtree: false });
    // An already visible link is not scrolled by the browser, even when the fixed banner covers it.
    document.addEventListener('focusin', revealFocus);
    sync();
  })();

  // Store-currency facts (at-facts.liquid), including after section paints: the checkout's rate, rounded up to a whole
  // amount so the stated threshold is never below the real one ("NZ$190", not "NZ$189.80"). The server's explicitly
  // labelled AUD amount stays when no matching exchange rate is available.
  function convertMoneyFact(el) {
    var cur = window.Shopify && window.Shopify.currency;
    if (!cur || cur.active !== el.dataset.currency || cur.active === 'AUD') return;
    var rate = Number(cur.rate);
    var cents = Number(el.dataset.atMoneyAud);
    if (!(rate > 0) || !Number.isFinite(cents)) return;
    el.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: cur.active, minimumFractionDigits: 0, maximumFractionDigits: 0,
    }).format(Math.ceil(Math.round(cents * rate) / 100));
  }
  if (!customElements.get('at-money')) {
    customElements.define('at-money', class extends HTMLElement {
      connectedCallback() { convertMoneyFact(this); }
    });
  }
  // Shortcut notes are plain strings in the search index. Convert just their fact markup before the search parses them.
  function currencyFactText(text) {
    return text.replace(/<at-money\b[^>]*>[^<]*<\/at-money>/g, function (markup) {
      var template = document.createElement('template');
      template.innerHTML = markup;
      var el = template.content.firstElementChild;
      convertMoneyFact(el);
      return el.textContent;
    });
  }

  // Currency rows arrive after <main> in <template id="AtCurrencyRows"> (at-footer.liquid),
  // so they no longer hold up the page's first photo. The first focus, press, key or click on the selector or on a
  // trigger copies them into its list, in the capture phase, so they are in place before localization-form.js opens
  // the panel. localization-form.js binds row clicks only for rows present when it starts, so the choice is submitted
  // below (what its onItemClick does: country_code, then submit), unless its own handler already ran.
  function fillCurrency() {
    var t = document.getElementById('AtCurrencyRows');
    var list = document.querySelector('.at-currency .at-currency-list');
    if (!t || !list || list.querySelector('a[data-value]')) return;
    list.insertBefore(t.content.cloneNode(true), list.querySelector('.at-currency-none'));
  }
  ['focusin', 'pointerdown', 'keydown', 'click'].forEach(function (type) {
    document.addEventListener(
      type,
      function (e) {
        if (e.target.closest && e.target.closest('.at-currency, .at-currency-trigger')) fillCurrency();
      },
      true
    );
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.at-currency a[data-value]');
    if (!a || e.defaultPrevented) return;
    e.preventDefault();
    var f = a.closest('localization-form');
    var input = f && f.querySelector('input[name="country_code"]');
    if (!input) return;
    input.value = a.dataset.value;
    f.querySelector('form').submit();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.at-nav')) closeOthers(null);

    var t = e.target.closest('.at-currency-trigger');
    if (!t) return;
    var btn = document.querySelector('.at-currency button.localization-form__select');
    if (!btn) return;
    // The drawer is closed first so its body lock (overflow-hidden-tablet) is gone before localization-form.js adds its own.
    var drawer = document.getElementById('Details-menu-drawer-container');
    if (drawer && drawer.hasAttribute('open')) drawer.querySelector('summary').click();
    // Safari does not focus a tapped button, so localization-form.js (which returns focus on close to what had focus
    // when it opened) would drop it to <body>: the footer trigger takes focus first. From the menu the menu button has
    // it already (the drawer's close returns it there).
    else t.focus({ preventScroll: true });
    if (btn.getAttribute('aria-expanded') !== 'true') btn.click();
    // On phones the header button is display:none (atelier.css), so localization-form.js's focus() on it is a no-op and
    // its Escape/focusout handlers (on the <localization-form>) would never see focus. Park focus on the sheet's close
    // button instead; it is visible there and does not raise the keyboard.
    var form = btn.closest('localization-form');
    var close = form && form.querySelector('.at-currency-close');
    if (close && window.matchMedia('(max-width:800px)').matches) close.focus();
  });
  // Instant search loader (docs/BUILD-NOTES.md, Instant search). Except on a submitted /search page, the first time the
  // shopper opens a search UI (presses the search icon or the menu burger, or focuses any search field), this adds
  // at-search.css and at-search.js and fetches the index in parallel: the collections list plus every product page of
  // /collections/all?view=search-index. The index is kept in sessionStorage under a key that changes with currency,
  // country, language, catalogue size and the Search settings. If a request fails, the next open tries again; until
  // the index is in, at-search.js answers from Shopify's Predictive Search API.
  function searchIndex(cfg) {
    var key = 'atSearch:' + cfg.key + ':currency-facts-v1';
    var cached = null;
    try {
      if (!cfg.design) cached = sessionStorage.getItem(key);
    } catch (e) {}
    if (cached) {
      try {
        return Promise.resolve(JSON.parse(cached));
      } catch (e) {}
    }
    // While a theme is only being previewed (not the published one), ask for its own index explicitly: if the
    // preview session is lost on the shopper's device, a bare request would be answered by the published theme,
    // which has no search-index template. Nothing is added on the published theme.
    var th = window.Shopify && window.Shopify.theme;
    var preview = th && th.role !== 'main' && th.id ? 'preview_theme_id=' + th.id : '';
    function get(u) {
      if (preview) u += (u.indexOf('?') < 0 ? '?' : '&') + preview;
      return fetch(u, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      });
    }
    var pages = Math.max(1, Math.ceil(cfg.count / 250));
    var reqs = [get(cfg.collections)];
    for (var i = 1; i <= pages; i++) reqs.push(get(cfg.products + '&page=' + i));
    return Promise.all(reqs).then(function (res) {
      var c = res.shift();
      var more = [];
      for (var i = pages + 1; i <= res[0].pages; i++) more.push(get(cfg.products + '&page=' + i));
      return Promise.all(more).then(function (extra) {
        var data = { b: res[0].b, p: [], c: c.c, pop: c.pop, syn: c.syn, map: c.map, pt: c.pt };
        res.concat(extra).forEach(function (r) {
          data.p = data.p.concat(r.p);
        });
        try {
          if (!cfg.design) sessionStorage.setItem(key, JSON.stringify(data));
        } catch (e) {}
        return data;
      });
    });
  }
  function bootSearch() {
    var el = document.getElementById('AtSearchConfig');
    if (!el) return;
    var cfg = window.atSearchCfg || (window.atSearchCfg = JSON.parse(el.textContent));
    if (!window.atSearchIndex && !window.atSearchData) {
      window.atSearchIndex = searchIndex(cfg).then(
        function (data) {
          data.map = data.map.map(currencyFactText);
          window.atSearchData = data;
          if (window.atSearch) window.atSearch.use(data);
          return data;
        },
        function () {
          window.atSearchIndex = null;
        }
      );
    }
    loadSearchFiles(cfg);
  }
  // at-search.css and at-search.js load side by side; the script waits to start until the stylesheet has applied
  // (window.atSearchCss, and window.atSearchBoot, which the stylesheet's load event calls), so results never show
  // without their dropdown layout and then jump when it lands. A file that fails to load is removed and fetched again
  // on the next open, instead of leaving instant search off for the rest of the visit.
  var searchJs = ''; // '' | 'loading' | 'done'
  var searchLink = null;
  function loadSearchFiles(cfg) {
    if (!searchLink || !searchLink.isConnected || window.atSearchCss === 'failed') {
      window.atSearchCss = 'loading';
      var link = document.createElement('link');
      searchLink = link;
      link.rel = 'stylesheet';
      link.href = cfg.css;
      link.onload = function () {
        window.atSearchCss = 'done';
        var boot = window.atSearchBoot;
        window.atSearchBoot = null;
        if (boot) boot();
        searchWait(document.activeElement);
      };
      link.onerror = function () {
        link.remove();
        window.atSearchCss = 'failed';
      };
      document.head.appendChild(link);
    }
    if (searchJs) return;
    searchJs = 'loading';
    var script = document.createElement('script');
    script.src = cfg.js;
    script.async = true;
    script.onload = function () {
      searchJs = 'done';
    };
    script.onerror = function () {
      script.remove();
      searchJs = '';
    };
    document.head.appendChild(script);
  }
  // Typing can beat the lazy script too, especially on a cold connection. The stylesheet's gate keeps this one
  // quiet status row from ever painting unstyled; at-search.js takes over as soon as it arrives.
  function searchWait(input) {
    if (window.atSearch || !input || !input.matches('[data-at-search] input[type="search"][aria-controls]')) return;
    var list = document.getElementById(input.getAttribute('aria-controls'));
    if (!list) return;
    list.replaceChildren();
    list.hidden = !input.value.trim();
    input.setAttribute('aria-expanded', String(!list.hidden));
    if (list.hidden) return;
    var message = document.createElement('p');
    message.className = 'at-sr-row at-sr-msg at-sr-wait';
    message.setAttribute('role', 'status');
    message.textContent = window.atSearchCfg.t.searching;
    list.appendChild(message);
  }
  document.addEventListener('input', function (e) {
    searchWait(e.target);
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && searchLink) bootSearch();
  });
  if (document.getElementById('AtSearchContext')) bootSearch();
  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.target.closest && e.target.closest('.header__icon--search, summary.at-menu')) bootSearch();
    },
    true
  );
  document.addEventListener('focusin', function (e) {
    if (e.target.matches && e.target.matches('[data-at-search] input[type="search"]')) bootSearch();
  });
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (d.open && d.matches && d.matches('#Details-menu-drawer-container')) bootSearch();
    },
    true
  );

  /* Body classes for atelier.css, which hides the Inbox chat pill on phones while the menu drawer is open (the close
     animation included: [open] goes when it ends, and so does the class) and while a text field has focus. They were
     :has() rules on <body>, which made every [open] or focus change anywhere restyle the whole page. */
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (d.id === 'Details-menu-drawer-container') document.body.classList.toggle('at-menu-open', d.open);
    },
    true
  );
  var typingField = 'input:not([type=hidden],[type=checkbox],[type=radio],[type=submit],[type=button]),textarea,select';
  function syncTyping() {
    var a = document.activeElement;
    var on = !!(a && a.matches && a.matches(typingField));
    if (document.body.classList.contains('at-typing') !== on) document.body.classList.toggle('at-typing', on);
  }
  document.addEventListener('focusin', syncTyping);
  document.addEventListener('focusout', function () {
    setTimeout(syncTyping);
  });
  syncTyping(); // a field focused before this deferred file ran

  /* Phone menu: the Search row at the foot of the drawer (sections/at-header.liquid) focuses the field at the top of
     the drawer inside the tap itself, so iOS raises the keyboard and the instant results open under the field as they
     do when the field is tapped. While that field has focus or text the drawer carries .is-search-active and the row
     steps away (atelier.css); it comes back once the field is cleared and has lost focus. at-search.js writes the
     field (Escape, Clear, a recent search) with an input event, so every change passes through here. */
  function drawerField() {
    return document.querySelector('.at-drawer-search input[type="search"]');
  }
  function footState(focused) {
    var input = drawerField();
    var drawer = input && input.closest('.at-drawer');
    if (drawer) drawer.classList.toggle('is-search-active', focused || input.value.trim() !== '');
  }
  // Captured and stopped: Dawn's MenuDrawer (global.js) binds every <button> in the drawer to its close handler, which
  // would shut the menu under the tap (the accordion summaries above are shielded the same way).
  document.addEventListener(
    'click',
    function (e) {
      if (!(e.target.closest && e.target.closest('.at-drawer-foot-search'))) return;
      e.stopPropagation();
      var input = drawerField();
      if (input) input.focus({ preventScroll: true });
    },
    true
  );
  document.addEventListener('focusin', function (e) {
    if (e.target === drawerField()) footState(true);
  });
  document.addEventListener('focusout', function (e) {
    if (e.target === drawerField()) footState(false);
  });
  document.addEventListener('input', function (e) {
    if (e.target === drawerField()) footState(document.activeElement === e.target);
  });

  /* Header search bar (snippets/header-search.liquid; docs/BUILD-NOTES.md, Header group, Header search).
     The search icon is a link to /search (so it still works before this file loads, or without scripts); here it opens
     a dialog laid over the header instead. The field is focused inside the click itself: iOS only raises the keyboard
     for a focus() made within the shopper's gesture. Opening: the pill is revealed from a circle round the icon
     (clip-path), its search button glides from the icon to the pill's right end, the field and the X fade in, and the
     rest of the header fades and slides aside (CSS, .at-head.is-searching). Closing plays the same animations back
     (a reopen or close half way reverses them from where they are). Closes on the X, Escape (with text typed, the
     first Escape clears the field, in at-search.js), a click or tap outside the bar and its results (the scrim
     included; see pointerup below), choosing a result, focus moving elsewhere, and, only while the field is empty, scrolling the page more
     than 24px. Focus returns to the icon. Tab and Shift+Tab cycle through the field, the search button, the result
     rows and the X. Reduced motion: no animation, the bar swaps in and out. */
  var HS_EASE = 'cubic-bezier(.2,.7,.3,1)';
  var HS_OPEN_MS = 220;
  var HS_CLOSE_MS = 200;
  var HS_SCROLL = 24;
  var hsStill = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hs = null;

  function hsCentre(el) {
    var r = (el.querySelector('svg') || el).getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }
  function hsStop(s) {
    s.anims.forEach(function (a) {
      a.cancel();
    });
    s.anims = [];
    s.bar.classList.remove('is-anim');
  }
  // Grow out of the icon (opening) or shrink back into it; done runs when the movement ends.
  function hsAnimate(s, opening, done) {
    if (s.anims.length && s.opening !== opening) {
      // Still moving the other way: turn round from where everything is now.
      s.opening = opening;
      s.anims.forEach(function (a) {
        a.reverse();
      });
      s.anims[0].onfinish = done;
      return;
    }
    hsStop(s);
    s.opening = opening;
    if (hsStill.matches) return done();
    var form = s.bar.querySelector('.at-hs-form');
    var go = s.bar.querySelector('.at-hs-go');
    var x = s.bar.querySelector('.at-hs-close');
    var f = form.getBoundingClientRect();
    var t = hsCentre(s.trigger);
    var g = hsCentre(go);
    var d = f.height;
    var left = Math.max(0, Math.min(f.width - d, t.x - d / 2 - f.left));
    // The shape grows from a circle round the icon to the field's own corners (8px on phones, square on computers,
    // decision 40), so the clip's corner radius animates from d / 2 to the field's radius.
    var r = Math.min(d / 2, parseFloat(getComputedStyle(form).borderTopLeftRadius) || 0);
    var circle = 'inset(0px ' + (f.width - d - left) + 'px 0px ' + left + 'px round ' + d / 2 + 'px)';
    var pill = 'inset(0px 0px 0px 0px round ' + r + 'px)';
    // On phones the circle is clamped to the pill's edge, 10px left of the icon: the magnifier must still meet the
    // icon itself or it jumps at the handoff. Where the capped pill ends beside the icon (wide screens), start in
    // the circle instead, so the magnifier is inside the visible shape from the first frame.
    var onIcon = Math.abs(t.x - g.x) < 12 && Math.abs(t.y - g.y) < 12;
    var fromIcon = 'translate(' + ((onIcon ? t.x : f.left + left + d / 2) - g.x) + 'px,' + (t.y - g.y) + 'px)';
    var o = { duration: opening ? HS_OPEN_MS : HS_CLOSE_MS, easing: HS_EASE, fill: 'both' };
    // Keyframes are written for opening; closing plays them backwards (offsets mirrored).
    function k(frames) {
      if (opening) return frames;
      return frames
        .slice()
        .reverse()
        .map(function (fr) {
          var c = {};
          for (var p in fr) c[p] = fr[p];
          if (c.offset != null) c.offset = 1 - c.offset;
          return c;
        });
    }
    s.anims = [
      form.animate(k([{ clipPath: circle }, { clipPath: pill }]), o),
    ];
    // The rounded ends: half-rings on the clip's two ends (the clip cuts through the form's border there), moving with
    // it on the same clock, in the border's current colour.
    var caps = s.bar.querySelectorAll('.at-hs-cap');
    if (caps.length === 2) {
      var b = s.bar.getBoundingClientRect();
      var col = getComputedStyle(form).borderTopColor;
      [caps[0], caps[1]].forEach(function (c, i) {
        var st = c.style;
        st.top = f.top - b.top + 'px';
        st.left = (i ? f.right - d / 2 : f.left) - b.left + 'px';
        st.width = d / 2 + 'px';
        st.height = d + 'px';
        st.borderColor = col;
        st.borderRadius = i ? '0 ' + d / 2 + 'px ' + d / 2 + 'px 0' : d / 2 + 'px 0 0 ' + d / 2 + 'px';
      });
      var capRound = function (i, v) {
        return i ? '0 ' + v + 'px ' + v + 'px 0' : v + 'px 0 0 ' + v + 'px';
      };
      s.bar.classList.add('is-anim');
      s.anims.push(
        caps[0].animate(k([{ transform: 'translateX(' + left + 'px)', borderRadius: capRound(0, d / 2) }, { transform: 'none', borderRadius: capRound(0, r) }]), o),
        caps[1].animate(k([{ transform: 'translateX(' + -(f.width - d - left) + 'px)', borderRadius: capRound(1, d / 2) }, { transform: 'none', borderRadius: capRound(1, r) }]), o)
      );
      if (!opening) caps.forEach(function (c) {
        s.anims.push(c.animate([{ opacity: 1 }, { opacity: 1, offset: 0.5 }, { opacity: 0 }], { duration: o.duration, easing: 'linear', fill: 'both' }));
      });
    }
    // Closing only: the pill fades over the second half, on the clock rather than the ease, whose slow tail otherwise
    // left a small ring round the icon for about 100ms. Where its search button ends on the icon (phones), only the
    // outline fades: the button stays solid all the way back and the icon reappears (CSS) as it arrives, so one
    // magnifier shows throughout (fading the whole pill showed both side by side for about 5 frames on iPhone). Where
    // the button ends beside the icon (wide screens), the whole pill fades and the icon fading back in meets it there.
    // (Opening keeps the pill opaque: it covers the icon it grows from, so the two magnifiers never show together.)
    if (!opening) {
      var ring = getComputedStyle(form).borderTopColor;
      s.anims.push(form.animate(onIcon ? [{ borderColor: ring }, { borderColor: ring, offset: 0.5 }, { borderColor: 'transparent' }] : [{ opacity: 1 }, { opacity: 1, offset: 0.5 }, { opacity: 0 }], { duration: o.duration, easing: 'linear', fill: 'both' }));
    }
    s.anims.push(
      go.animate(k([{ transform: fromIcon }, { transform: 'none' }]), o),
      s.input.animate(k([{ opacity: 0 }, { opacity: 0, offset: 0.8 }, { opacity: 1 }]), o), // the words fade in over the last fifth of the growth (eased): earlier they ran under the growing left end
      // The X arrives last, over the second half (after the bag under it has faded, atelier.css, 120ms), and leaves
      // first, in 80ms, before the header's own items come back (from 60ms).
      opening
        ? x.animate([{ opacity: 0, transform: 'translateX(-8px)' }, { opacity: 1, transform: 'none' }], { duration: HS_OPEN_MS / 2, delay: HS_OPEN_MS / 2, easing: HS_EASE, fill: 'both' })
        : x.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 80, easing: 'ease-out', fill: 'both' })
    );
    s.anims[0].onfinish = done;
  }

  function openSearch(trigger, restoring) {
    var bar = document.getElementById(trigger.getAttribute('aria-controls'));
    var input = bar && bar.querySelector('input[type="search"]');
    if (!input) return false;
    if (hs && hs.bar !== bar) hsReset(hs);
    var s = hs && hs.bar === bar ? hs : { bar: bar, input: input, head: bar.closest('.at-head') || bar.parentNode, anims: [] };
    hs = s;
    s.trigger = trigger;
    if (s.open) return input.focus(), true;
    s.open = true;
    closeOthers(null);
    bar.classList.remove('is-closing');
    bar.hidden = false;
    // Inside the click, so phones raise the keyboard in the same tap. Anything typed before is kept and selected.
    input.focus({ preventScroll: true });
    if (input.value && !restoring) input.select();
    s.head.classList.add('is-searching');
    hsPage(true);
    trigger.setAttribute('aria-expanded', 'true');
    bootSearch();
    // Scrolling closes an empty bar; the page may still move while it opens (iOS settles the keyboard), so the
    // starting point is taken again when the opening ends.
    s.settling = true;
    s.y = window.scrollY;
    function opened() {
      hsStop(s);
      s.settling = false;
      s.y = window.scrollY;
    }
    if (restoring) opened();
    else hsAnimate(s, true, opened);
    saveSearch();
    return true;
  }

  // refocus: undefined puts focus back on the icon (keyboard closes); 'quiet' does too, without a focus ring (a tap, a
  // click or a scroll closed it: Chromium would otherwise show the ring, because focus came from the field); false
  // leaves focus where the shopper put it.
  function closeSearch(refocus) {
    var s = hs;
    if (!s || !s.open) return;
    s.open = false;
    s.settling = false;
    saveSearch();
    var a = document.activeElement;
    var lost = !a || a === document.body || s.bar.contains(a);
    s.trigger.setAttribute('aria-expanded', 'false');
    s.head.classList.remove('is-searching');
    hsPage(false);
    s.bar.classList.add('is-closing');
    if (refocus !== false && lost) {
      s.trigger.classList.toggle('is-quiet', refocus === 'quiet');
      s.trigger.focus({ preventScroll: true });
    }
    hsAnimate(s, false, function () {
      hsReset(s);
    });
  }

  // Page-level changes while the bar is open, kept off <html> and <body> classes: a class there restyles the whole
  // document (about 22ms of the opening frame at 4x CPU). The field sits inside the sticky header, under the root's
  // scroll-padding-top, so each keystroke scrolled the page up ~49px to "reveal" the caret: the padding is lifted
  // inline. Klaviyo's teaser (bottom left) and, on phones, the Inbox chat pill (bottom right) would cover the results:
  // hidden by a class on each (at-klaviyo.css, atelier.css), as they are under the drawers.
  function hsPage(on) {
    document.documentElement.style.scrollPaddingTop = on ? '0px' : '';
    document.querySelectorAll('div[class*="kl-teaser-"]').forEach(function (t) {
      t.classList.toggle('at-kl-hide', on);
    });
    var chat = document.querySelector('shopify-chat');
    if (chat) chat.classList.toggle('at-hs-away', on); // phones only (atelier.css)
  }

  // Closed at once, no animation (end of a close, a stale header after an editor re-render, a page restored from the
  // back-forward cache).
  function hsReset(s) {
    hsStop(s);
    s.open = false;
    s.settling = false;
    s.bar.hidden = true;
    s.bar.classList.remove('is-closing');
    s.head.classList.remove('is-searching');
    if (s.trigger) s.trigger.setAttribute('aria-expanded', 'false');
    hsPage(false);
  }

  // Tab stops inside the bar: field, search button, result rows (links, tabindex -1 for the combobox) and the recent
  // searches' Clear, X.
  function hsStops(s) {
    var list = [s.input, s.bar.querySelector('.at-hs-go')];
    s.bar.querySelectorAll('.at-sr:not([hidden]) [role="option"], .at-sr:not([hidden]) .at-sr-clear').forEach(function (o) {
      list.push(o);
    });
    list.push(s.bar.querySelector('.at-hs-close'));
    return list;
  }

  document.addEventListener('click', function (e) {
    var mod = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button;
    var trigger = e.target.closest && e.target.closest('.at-hs-open');
    if (trigger) {
      if (!mod && openSearch(trigger)) e.preventDefault();
      return;
    }
    var s = hs;
    if (!s || !s.open) return;
    if (e.target.closest('.at-hs-close')) return closeSearch(e.detail ? 'quiet' : undefined); // detail 0: Enter or Space
    var row = e.target.closest('[role="option"]');
    if (row && s.bar.contains(row)) {
      // The bar and its results stay where they are until the next page replaces them (at-search.js shows the wait),
      // rather than closing first and showing the page underneath while the result loads. A link to a place on this
      // same page loads nothing, so that one closes the bar.
      if (!mod && row.pathname === location.pathname && row.search === location.search && row.hash) closeSearch(false);
      return;
    }
    if (e.target === s.bar) s.input.focus(); // the header's empty ends beside the pill
  });

  // A tap or click outside the bar and its results (the scrim included) closes it. Taken from pointerdown + pointerup
  // rather than click: iOS sends no click for a tap on plain page content, and a touch that turns into a scroll ends
  // in pointercancel, so scrolling past the results with text typed never closes the bar. The scrim keeps catching
  // taps while the bar closes (atelier.css), so the click that follows does not land on the page beneath.
  var hsDown = null;
  document.addEventListener(
    'pointerdown',
    function (e) {
      hsDown = hs && hs.open ? { id: e.pointerId, x: e.clientX, y: e.clientY, t: e.target } : null;
      // No compatibility mousedown from a touch on the scrim: it would take focus off the icon right after the close
      // put it there. Scrolling still works (that is touch-action, not this).
      if (hsDown && e.target.classList && e.target.classList.contains('at-hs-scrim')) e.preventDefault();
    },
    true
  );
  document.addEventListener(
    'pointerup',
    function (e) {
      var d = hsDown;
      var s = hs;
      hsDown = null;
      if (!d || !s || !s.open || d.id !== e.pointerId) return;
      if (Math.abs(e.clientX - d.x) > 10 || Math.abs(e.clientY - d.y) > 10) return;
      if (!s.bar.contains(d.t) || d.t.classList.contains('at-hs-scrim')) closeSearch('quiet');
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    var s = hs;
    var q = document.querySelector('.at-hs-open.is-quiet');
    if (q && e.key === 'Tab') q.classList.remove('is-quiet'); // tabbing on from the icon shows rings again
    if (e.key === ' ' && e.target.closest && e.target.closest('.at-hs-open')) {
      // role=button on a link: Space opens it as it would a button.
      e.preventDefault();
      openSearch(e.target.closest('.at-hs-open'));
      return;
    }
    if (!s || !s.open || !s.bar.contains(e.target)) return;
    if (e.key === 'Escape') {
      // at-search.js has already taken a first Escape that cleared typed text (it stops the event).
      e.preventDefault();
      closeSearch();
    } else if (e.key === 'Tab') {
      var stops = hsStops(s);
      var i = stops.indexOf(document.activeElement);
      e.preventDefault();
      stops[(i + (e.shiftKey ? -1 : 1) + stops.length) % stops.length].focus();
    } else if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && e.target.getAttribute('role') === 'option') {
      // On a row reached with Tab, the arrows move between rows and back up to the field.
      var rows = hsStops(s).slice(2, -1);
      var j = rows.indexOf(e.target) + (e.key === 'ArrowDown' ? 1 : -1);
      e.preventDefault();
      (j < 0 ? s.input : rows[Math.min(j, rows.length - 1)]).focus();
    }
  });

  // Focus moving anywhere outside the bar (a screen reader's cursor, another field) closes it where focus now is.
  document.addEventListener('focusin', function (e) {
    var s = hs;
    if (s && s.open && !s.bar.contains(e.target)) closeSearch(false);
  });

  window.addEventListener(
    'scroll',
    function () {
      var s = hs;
      if (!s || !s.open) return;
      var y = window.scrollY;
      // With text typed the bar stays (the shopper may be reading past the results); the empty-field distance counts
      // from wherever the page was when the field last emptied.
      if (s.settling || s.input.value.trim()) s.y = y;
      else if (Math.abs(y - s.y) > HS_SCROLL) closeSearch('quiet');
    },
    { passive: true }
  );

  // Save before navigation: WebKit can discard replaceState from pagehide after a full-search submission.
  // Quiet typing is coalesced to avoid Safari's history-write limit; leaving a field or choosing a result saves now.
  var searchSaveTimer;
  var restoringSearch = false;
  function saveSearch() {
    if (restoringSearch) return;
    clearTimeout(searchSaveTimer);
    var fields = {};
    document.querySelectorAll('[data-at-search="page"] input[type="search"][id]').forEach(function (input) {
      fields[input.id] = { q: input.value, open: input.getAttribute('aria-expanded') === 'true' };
    });
    var header = document.getElementById('Search-In-Header');
    var state = Object.assign({}, history.state, { atSearchFields: fields });
    if (header) state.atHeaderSearch = { q: header.value, open: !!(hs && hs.open) };
    history.replaceState(state, '');
  }
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-at-search] input[type="search"]')) return;
    if (e.target.form) {
      e.target.form.classList.remove('is-going');
      e.target.form.removeAttribute('aria-busy');
    }
    clearTimeout(searchSaveTimer);
    searchSaveTimer = setTimeout(saveSearch, 400);
  });
  document.addEventListener('focusout', function (e) {
    if (e.target.matches('[data-at-search] input[type="search"]')) saveSearch();
  });
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-at-search]')) return;
    saveSearch();
    e.target.classList.add('is-going');
    e.target.setAttribute('aria-busy', 'true');
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[href]')) saveSearch();
  }, true);
  window.addEventListener('pagehide', function () { clearTimeout(searchSaveTimer); });

  function restoreSearch() {
    var state = history.state || {};
    var saved = state.atHeaderSearch;
    restoringSearch = true;
    document.querySelectorAll('form[data-at-search].is-going').forEach(function (form) {
      form.classList.remove('is-going');
      form.removeAttribute('aria-busy');
    });
    if (hs) hsReset(hs);
    var input = document.getElementById('Search-In-Header');
    var trigger = document.querySelector('.at-hs-open');
    if (saved && input && trigger) {
      input.value = saved.q;
      if (saved.open) {
        openSearch(trigger, true);
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
    Object.keys(state.atSearchFields || {}).forEach(function (id) {
      var field = document.getElementById(id);
      var value = state.atSearchFields[id];
      if (!field) return;
      field.value = value.q;
      if (value.open && !(saved && saved.open)) {
        field.focus({ preventScroll: true });
        field.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    restoringSearch = false;
  }
  // This deferred file runs at DOMContentLoaded, before slow photos and apps can hold up load/pageshow.
  var searchNav = performance.getEntriesByType('navigation')[0];
  if (searchNav && searchNav.type === 'back_forward') restoreSearch();
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) restoreSearch();
  });
  document.addEventListener('shopify:section:load', function () {
    if (hs && !document.contains(hs.bar)) {
      hsReset(hs);
      hs = null;
    }
  });

  // Home testimonials (sections/at-quote.liquid): the review row scrolls sideways only on phones (at-home.css), so only
  // there is it a Tab stop (tabindex=0, for arrow-key scrolling). From 801px it shows two or three whole cards and does
  // not move, and its focus ring drew two rose lines across the page. The markup keeps tabindex (no-JS keeps the old
  // behaviour); this follows the breakpoint as it changes and after an editor re-render.
  var quotesMq = window.matchMedia('(max-width:800px)');
  function syncQuotes() {
    document.querySelectorAll('.at-quotes-track').forEach(function (t) {
      if (quotesMq.matches) t.setAttribute('tabindex', '0');
      else t.removeAttribute('tabindex');
    });
  }
  syncQuotes();
  if (quotesMq.addEventListener) quotesMq.addEventListener('change', syncQuotes);
  document.addEventListener('shopify:section:load', syncQuotes);

  // Currency search with no match: atelier.css shows .at-currency-none once localization-form.js has hidden every
  // country; this keeps its words (data-text, from the locale) in step with what was typed.
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('.at-currency .country-filter__input')) return;
    var none = e.target.closest('.at-currency').querySelector('.at-currency-none');
    if (none) none.textContent = none.getAttribute('data-text').replace('%q%', e.target.value.trim());
  });

  // Safari does not focus a link on click, so the selector's focusout handler would close the list before the country
  // click lands. Keeping focus where it is on mousedown lets localization-form.js's click handler submit.
  document.addEventListener('mousedown', function (e) {
    if (e.target.closest && e.target.closest('.at-currency a[data-value]')) e.preventDefault();
  });
})();
